export default __webpack_public_path__ + "static/media/hht2_quiztime.caca178c.png";